import { ExpandLess, ExpandMore } from '@mui/icons-material';
import { Box, Collapse, Stack, Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
type Props = {
  children: React.ReactNode;
  upcomingChangesOpen: boolean;
  setUpComingChangesOpen: React.Dispatch<React.SetStateAction<boolean>>;
};
export const UpcomingChangesWrapper = ({
  children,
  upcomingChangesOpen,
  setUpComingChangesOpen,
}: Props) => {
  const { t } = useTranslation();
  const textColor = upcomingChangesOpen ? 'black' : '#05A4D8';
  return (
    <Stack spacing={1} marginTop={2}>
      <Box
        display="flex"
        alignItems="center"
        onClick={() => setUpComingChangesOpen(!upcomingChangesOpen)}
        sx={{ cursor: 'pointer' }}
      >
        {upcomingChangesOpen ? (
          <ExpandLess
            fontSize="small"
            sx={{
              marginRight: 1,
              color: textColor,
            }}
          />
        ) : (
          <ExpandMore
            fontSize="small"
            sx={{
              marginRight: 1,
              color: textColor,
            }}
          />
        )}
        <Typography
          sx={{
            fontWeight: 'bold',
            color: textColor,
          }}
        >
          {t('upcomingChanges')}
        </Typography>
      </Box>
      <Collapse in={upcomingChangesOpen} easing={'easing'} timeout={500}>
        <Stack spacing={1} direction="column">
          {children}
        </Stack>
      </Collapse>
    </Stack>
  );
};
